export enum TemplateFieldType {
  Candidate = "Candidate",
  Email = "Email",
  Recruiter = "Recruiter",
  Forms = "Forms",
}
